<template>
  <div>
    <!--搜索栏-->
    <searchBar
      :search-form="searchForm"
      bigdata-year
      btn-add
      @handleAdd="dialogFormVisible = true"
      @handleSearch="getData"
    ></searchBar>

    <!--表格-->
    <el-table :data="tableData" border>
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="60"
      ></el-table-column>
      <el-table-column
        v-for="(item, index) in tableHeader"
        :key="index"
        :label="item"
        :prop="index"
        align="center"
      ></el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="250">
        <template slot-scope="scope">
          <el-button
            @click="handleSequence(scope.row, 1)"
            type="text"
            :disabled="(page - 1) * size + scope.$index + 1 === 1"
            class="text-gray"
            size="mini"
          >
            上移
          </el-button>
          <el-button
            @click="handleSequence(scope.row, 2)"
            type="text"
            :disabled="
              totalElements - ((page - 1) * size + scope.$index + 1) === 0
            "
            size="mini"
          >
            下移
          </el-button>
          <el-button @click="handleEdit(scope.row)" type="text" size="mini">
            编辑
          </el-button>
          <el-button
            @click="handleDelete(scope.row)"
            type="text"
            style="color: red"
            size="mini"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="block">
      <el-pagination
        class="pagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="size"
        layout=" prev, pager, next, jumper, sizes"
        :total="totalElements"
      ></el-pagination>
    </div>

    <!--新增商铺Dialog-->
    <el-dialog
      title="新增/修改数据"
      :show-close="false"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="100px"
        label-suffix="："
        label-position="right"
        :status-icon="true"
      >
        <el-form-item label="年份" prop="year" label-width="100px">
          <el-input
            v-model="form.year"
            size="medium"
            placeholder="年份"
          ></el-input>
        </el-form-item>

        <el-form-item label="数值" prop="number" label-width="100px">
          <el-input-number
            v-model="form.number"
            size="medium"
            placeholder="数值"
            :min="0"
            style="display: flex"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCancel">取 消</el-button>
        <el-button type="primary" @click="dialogConfirm">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "@/assets/http/utils.ts"
import { quillEditor } from "vue-quill-editor"
import "quill/dist/quill.snow.css"
import { quillRedefine } from "vue-quill-editor-upload"

export default {
  data() {
    return {
      // 页面初始数据
      totalElements: 10,
      totalPages: 1,
      size: 10,
      page: 1,

      // 搜索栏初始化
      searchForm: {
        year: "",
        number: "",
      },

      // 表头初始化
      tableHeader: {
        year: "年份",
        number: "数值",
      },

      // 表格数据
      tableData: [],

      // dialog可见性
      dialogFormVisible: false,
      dialogUploadVisible: false,

      // 新增表单
      form: {
        uid: "",
        year: "",
        number: "",
      },

      // 表单验证规则
      rules: {
        name: {
          required: true,
          message: "请输入年份",
          trigger: "blur",
        },
        number: {
          required: true,
          message: "请输入数值",
          trigger: "blur",
        },
      },

      direction: "ASC",
      property: "sequence",
    }
  },
  methods: {
    /*请求数据*/
    getData() {
      this.request({
        url: "/manager/familyIncome/findFamilyIncome",
        method: "get",
        params: {
          page: this.page,
          size: this.size,
          year: this.searchForm.year,
          direction: this.direction,
          property: this.property,
        },
      })
        .then(res => {
          this.size = res.data.data.size
          this.page = res.data.data.page
          this.totalElements = Number(res.data.data.totalElements)
          this.totalElements = Number(res.data.data.totalElements)
          this.totalPages = res.data.data.totalPages
          this.tableData = res.data.data.content
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*更改单页数据数量*/
    handleSizeChange(size) {
      this.size = size
      this.getData()
    },

    /*页码跳转*/
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },

    /*编辑*/
    handleEdit(rowData) {
      this.form = { ...rowData }
      this.dialogFormVisible = true
    },

    /*删除*/
    handleDelete(rowData) {
      this.$confirm("确认删除?")
        .then(() => {
          this.request({
            url: "/manager/familyIncome/deleteFamilyIncome",
            params: {
              uid: rowData.uid,
            },
            method: "DELETE",
          })
            .then(res => {
              this.$message.success("删除成功")
              this.getData()
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        })
        .catch()
    },

    /*dialog提交*/
    dialogConfirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.dialogFormVisible = false
          this.request({
            url: "/manager/familyIncome/addOrUpdateFamilyIncome",
            data: {
              uid: this.form.uid,
              year: this.form.year,
              number: this.form.number,
            },
            method: "post",
          })
            .then(res => {
              this.getData()
              this.form = {}
            })
            .catch(err => {})
        }
      })
    },

    /*dialog取消*/
    dialogCancel() {
      this.dialogFormVisible = false
    },
    handleSequence(rowData, type) {
      this.request({
        url: "/manager/familyIncome/changeSequence",
        data: {
          uid: rowData.uid,
          type: type,
        },
        method: "post",
      })
        .then(res => {
          this.$message.success("操作成功")
          this.getData()
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },
  },
  mounted() {
    this.getData()
  },
}
</script>

<style scoped lang="scss"></style>
